import { z } from "zod";

/** Matches the per-result context cap, so one page carries as much as an unpaged result did. */
export const TEXT_READ_PAGE_LIMIT = 12_000;

/** Offsets count UTF-16 code units; pages never split a surrogate pair. */
export const TextReadPageInput = z.object({
  offset: z
    .number()
    .int()
    .min(0)
    .max(Number.MAX_SAFE_INTEGER)
    .default(0)
    .describe("UTF-16 offset from nextOffset; nonzero offsets require guard."),
  limit: z
    .number()
    .int()
    .min(2)
    .max(TEXT_READ_PAGE_LIMIT)
    .default(TEXT_READ_PAGE_LIMIT)
    .describe(`Maximum UTF-16 code units per page (2–${TEXT_READ_PAGE_LIMIT}).`),
  guard: z
    .string()
    .regex(/^[a-f0-9]{64}$/)
    .optional()
    .describe("Exact source guard from the previous page. Rejects changed content."),
});

export const ReadFileInput = TextReadPageInput.extend({
  path: z.string().min(1).max(1024),
}).strict();
